import rest from "@/rest-client";
import createCrudVuexModule from "./crud";
export default function createCustomSaveVuexModule({ namespaced = true, options, path, moduleName, state, getters, mutations, actions }) {
  const base = createCrudVuexModule({ namespaced, options, path, moduleName, state, getters, mutations, actions });

  return {
    moduleName,
    namespaced: namespaced,
    state: {
      ...base.state,
    },
    getters: {
      ...base.getters,
    },
    mutations: {
      ...base.mutations,
    },
    actions: {
      ...base.actions,

      async create({ getters, commit, dispatch }, payload) {
        try {
          commit("isUpdating", true);

          const response = await rest.post(`${path}`, payload);
          commit("editedEntity", undefined);
          return response;
        } finally {
          commit("isUpdating", false);
        }
      },

      async update({ getters, commit, dispatch }, payload) {
        try {
          commit("isUpdating", true);

          const response = await rest.put(`${path}`, payload);

          commit("editedEntity", undefined);
          return response;
        } finally {
          commit("isUpdating", false);
        }
      },
      ...actions,
    },
  };
}
